import FeatureFlagService from "../services/FeatureFlagService";
import type { RedirectPriorityEntry } from "./redirectPriority";

/**
 * Active-products snapshot for guard-failure triage logs: an unexpectedly
 * missing key (e.g. `common`) in this list is the usual root cause of a
 * route gate rejecting, so logging it makes a broken product catalog
 * visible straight from the browser console.
 *
 * Optional call: test doubles of the service often omit `getProducts`.
 */
export const activeProducts = (): string[] =>
  Object.keys(FeatureFlagService.getProducts?.() ?? {});

/**
 * A `REDIRECT_PRIORITY` entry is a valid redirect target only when its
 * destination's product gate would pass. Lives here so `redirectPriority.ts`
 * stays pure of FeatureFlagService. Callers that can render before
 * `initialize()` resolves must pair the reachable walk with an unrestricted
 * fallback (pre-init, every product reads inactive).
 *
 * TODO(PAMENG-1820): drop `productFallbackFeature` with the rollout fallbacks.
 */
export const isEntryProductReachable = (
  entry: RedirectPriorityEntry,
): boolean =>
  !entry.product ||
  FeatureFlagService.isProductActive(entry.product, entry.productFallbackFeature);
